module.exports = __webpack_public_path__ + "static/remember_the_milk_4-7bccbcbae2599357c854db1143a178ed.png";